module.exports = {
  calcInteractions: () => {
    let interactionsEl = document.querySelector('.interactions');
    
    let sixteenNineAspect = 16 / 9;
    let viewportHeight = window.innerHeight;
    let viewportWidth = window.innerWidth;
    let widthIfConstarainedByHeight = viewportHeight * sixteenNineAspect;
    let heightIfConstarainedByWidth = viewportWidth / sixteenNineAspect;
    
    if (widthIfConstarainedByHeight <= viewportWidth) {
      interactionsEl.style.width = widthIfConstarainedByHeight + "px";
      interactionsEl.style.height = viewportHeight + "px";
    } else {
      interactionsEl.style.width = viewportWidth + "px";
      interactionsEl.style.height = heightIfConstarainedByWidth + "px";
    }
  },
  calcModals: () => {
    let modalDialogEl = document.querySelector('.modal-dialog');

    if (!!modalDialogEl) {
      let sixteenNineAspect = 16 / 9;
      let viewportHeight = window.innerHeight;
      let viewportWidth = window.innerWidth;
      let widthIfConstarainedByHeight = viewportHeight * sixteenNineAspect;
      let heightIfConstarainedByWidth = viewportWidth / sixteenNineAspect;
      
      if (widthIfConstarainedByHeight <= viewportWidth) {
        modalDialogEl.style.width = widthIfConstarainedByHeight + "px";
        modalDialogEl.style.height = viewportHeight + "px";
      } else {
        modalDialogEl.style.width = viewportWidth + "px";
        modalDialogEl.style.height = heightIfConstarainedByWidth + "px";
      }
    }
  },
  showModalContent: () => {
    let content = document.querySelector('.modal-body > *');

    if (!!content) {
      content.classList.add('opacity-100');

      if (content.tagName === 'VIDEO') {
        content.play();
        content.addEventListener('click', () => {
          if (content.paused) {
            content.play();
          } else {
            content.pause();
          }
        });
      }
    }
  },
  hideModalContent: () => {
    let content = document.querySelector('.modal-body > *');

    if (!!content) {
      content.classList.remove('opacity-100');
    }
  }
}